import { Link } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/923179699957?text=Hi%20Moin%20Khan%20Boxing%20Academy!%20I%20want%20to%20join%20training';
const MOIN_KHAN_IMAGE = 'https://storage.readdy-site.link/project_files/ef254a84-69dd-4513-a7e4-f2f40f881f4f/f5b074be-dbde-4041-bdd9-c2e395680007_ChatGPT-Image-May-4-2026-06_19_11-AM.png?v=cccbe579b26a9daaee3bdbd9540372f1';

export default function HeroSection() {
  return (
    <section className="relative min-h-[100dvh] flex items-center overflow-hidden bg-boxing-black">
      {/* Desktop: Right side boxer image — clear and visible */}
      <div className="absolute right-0 top-0 bottom-0 w-[55%] md:w-[50%] lg:w-[48%] z-0 hidden md:block">
        <img
          src={MOIN_KHAN_IMAGE}
          alt="Moin Khan - International Boxer"
          className="w-full h-full object-cover object-center"
        />
        {/* Light left fade — just enough to blend, not hide */}
        <div className="absolute inset-0 bg-gradient-to-r from-boxing-black via-boxing-black/40 to-transparent" />
        {/* Very subtle bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-[15%] bg-gradient-to-t from-boxing-black to-transparent" />
        {/* Red rim light accent on right edge */}
        <div className="absolute inset-0 bg-gradient-to-l from-boxing-red/15 via-transparent to-transparent" />
      </div>

      {/* Mobile: image as full background with dark overlay */}
      <div className="absolute inset-0 z-0 md:hidden">
        <img
          src={MOIN_KHAN_IMAGE}
          alt="Moin Khan"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-boxing-black/60" />
        <div className="absolute inset-0 bg-gradient-to-b from-boxing-black/70 via-boxing-black/40 to-boxing-black/90" />
      </div>

      {/* Content — fills left side vertically, no wasted space */}
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12 w-full h-full flex items-center">
        <div className="max-w-xl lg:max-w-2xl py-12 md:py-16">
          <span className="section-label text-sm md:text-base mb-3 block">
            / International Level Training
          </span>

          <h1 className="font-bebas uppercase leading-[0.85] tracking-wide mb-5">
            <span className="block text-white text-6xl sm:text-7xl md:text-8xl lg:text-9xl">
              Train Like A
            </span>
            <span className="block text-boxing-red text-red-glow text-6xl sm:text-7xl md:text-8xl lg:text-9xl">
              Champion
            </span>
            <span className="block text-white/80 text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              with Moin Khan
            </span>
          </h1>

          <p className="font-poppins text-base md:text-lg text-white/90 max-w-md leading-relaxed mb-6">
            Train under Moin Khan — International Boxing Champion — and build strength, discipline, and confidence.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm md:text-base"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-lg" />
              </span>
              Join Now via WhatsApp
            </a>
            <Link to="/programs" className="btn-secondary text-sm md:text-base">
              View Programs
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
